import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
    import type { ChangedFields, Employee } from '@/types';
    import EmployeeChangesGroup from '../EmployeeChangesGroup.vue';
    import { useI18n } from 'vue-i18n';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CompanyPensionTab',
  props: {
    employee: {},
    data: {}
  },
  setup(__props: any) {

    const { t } = useI18n();

    const props = __props;

    const oldTypeVal = computed(() => {
        return props.data?.old?.type?.value ?? '';
    });

    const realTypeVal = computed(() => {
        return props.employee.company_pension?.type ?? '';
    });

    const oldPbs = computed(() => {
        return props.data?.old?.pbs?.value ?? '';
    });

    const newPbs = computed(() => {
        return props.data?.attributes?.pbs?.value ?? '';
    });

    const oldBankReg = computed(() => {
        return props.data?.old?.bank_reg?.value ?? '';
    });

    const newBankReg = computed(() => {
        return props.data?.attributes?.bank_reg?.value ?? '';
    });

    const alert = computed(() => {
        if (oldPbs.value !== newPbs.value || oldBankReg.value !== newBankReg.value) {
            return t('employee.pension_type_changed');
        }
    });

    const values = computed(() => {
        return [
            {
                name: 'type',
                group: 'companyPension',
                key: 'companyPension',
                oldValue:
                    oldTypeVal.value == 'amount'
                        ? t('employee.pension.type_option')
                        : oldTypeVal.value == 'percentage'
                          ? '%'
                          : '',
                realValue:
                    realTypeVal.value == 'amount'
                        ? t('employee.pension.type_option')
                        : realTypeVal.value == 'percentage'
                          ? '%'
                          : '',
            },
            {
                name: 'employee_contribution',
                group: 'companyPension',
                key: 'companyPension',
                realValue: props.employee.company_pension?.employee_contribution ?? '',
            },
            {
                name: 'company_contribution',
                group: 'companyPension',
                key: 'companyPension',
                realValue: props.employee.company_pension?.company_contribution ?? '',
            },
            {
                name: 'pension_company',
                group: 'companyPension',
                key: 'companyPension',
                realValue: props.employee.company_pension?.pension_company ?? '',
            },
        ];
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(EmployeeChangesGroup, {
    data: _ctx.data,
    values: values.value,
    employee: _ctx.employee,
    alert: alert.value
  }, null, 8, ["data", "values", "employee", "alert"]))
}
}

})